(ns minorodata.connections.sources.big-query
  (:require [minorodata.app.utils :as app.utils]))


(def source
  {:id                    "big-query"
   :enabled               true
   :message-queue-enabled true
   :name                  "Big Query"
   :description           "A fully-managed data warehouse from Google"
   :image-source          "bigquery.png"
   :tags                  ["data-import"]

   :preview-formatter
   (fn [source]
     (str "Client: "
          (get-in source [:credentials :client-email])
          ", project: "
          (get-in source [:credentials :project-id])))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [client-email client-id private-key private-key-id project-id
                    name description]} data]
        {:source-type "big-query"
         :name        name
         :description description

         :source
         {:credentials {:type           "service_account"
                        :client_email   client-email
                        :client_id      client-id
                        :private_key    private-key
                        :private_key_id private-key-id
                        :project_id     project-id}

          :files-prefix "big-query"}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge
         (select-keys credentials [:client-email :client-id :private-key :private-key-id :project-id])
         {:name        name
          :description description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :big-query-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Client Email"
              :name       :client-email
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Client ID"
              :name       :client-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Private Key"
              :name       :private-key
              :type       :password
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Private Key ID"
              :name       :private-key-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Project ID"
              :name       :project-id
              :required   true
              :value      ""}


             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status source-dataset source-table action destination-table gcs-bucket]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:source-dataset    source-dataset
                    :source-table      source-table
                    :destination-table destination-table
                    :action            action
                    :gcs-bucket        gcs-bucket}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:source-dataset :source-table :action :destination-table :gcs-bucket])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :big-query-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :input
              :label      "GCS Bucket Name"
              :name       :gcs-bucket
              :required   true
              :value      ""}

             {:block-type :input
              :label      "Dataset"
              :name       :source-dataset
              :required   true
              :value      ""}

             {:block-type :input
              :label      "Source table"
              :name       :source-table
              :required   true
              :value      ""}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
